import { render, staticRenderFns } from "./CardServeCenter.vue?vue&type=template&id=6a359687&scoped=true&"
import script from "./CardServeCenter.vue?vue&type=script&lang=js&"
export * from "./CardServeCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a359687",
  null
  
)

export default component.exports